// extracted by mini-css-extract-plugin
export var divider = "_ok-0";
export var systemMessage = "_ok-1";